import { useEffect, useState } from "react";
import {
  CDSHeader,
  CDSTenantMenuDivider,
  CDSTenantMenuRoot,
  CDSTenantMenuRow,
} from "@ciscodesignsystems/cds-react-header";
import { CDSLogoCisco } from "@ciscodesignsystems/cds-react-icons";
import { CDSButton } from "@ciscodesignsystems/cds-react-button";
import { Gear, SignOut, User } from "phosphor-react";
import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_SETTINGS, OVERVIEW } from "../app/paths";
import useLogOut from "../okta/useLogOut";

export const Header = () => {
  const [user, setUser] = useState({});
  const [showMenuContent, setShowMenuContent] = useState(false);
  const [logoutClicked, setLogoutClicked] = useState(false);
  const navigate = useNavigate();
  const logOut = useLogOut();

  useEffect(() => {
    const authData = localStorage.getItem("okta-token-storage");
    const auth = authData ? JSON.parse(authData) : null;

    if (auth?.idToken?.claims) {
      setUser({
        ...auth.idToken.claims,
        fullName: auth.idToken.claims.name,
      });
      return;
    }

    setUser({
      fullName: "API User",
      name: "API User",
      email: "api.user@cisco.com",
    });
  }, []);

  const handleLogout = async () => {
    if (logoutClicked) {
      return;
    }

    setLogoutClicked(true);

    try {
      await logOut();
    } finally {
      setLogoutClicked(false);
    }
  };

  const handleGlobalSettingsClick = () => {
    navigate(GLOBAL_SETTINGS, { replace: true });
    setShowMenuContent(false);
  };

  const handleLogoClick = (event) => {
    event.preventDefault();
    navigate(OVERVIEW, { replace: true });
  };

  return (
    <CDSHeader
      className="uag-header"
      sentiment="inverse"
      title="API Management Portal"
      logo={
        <CDSLogoCisco
          primaryTheme={{
            sentiment: "inverse",
            usage: "text",
          }}
        />
      }
      logoLinkProps={{ as: Link, to: OVERVIEW, onClick: handleLogoClick }}
    >
      <CDSTenantMenuRoot
        sentiment="inverse"
        switcherType="user"
        userName={user.fullName}
        showMenuContent={showMenuContent}
        onShowMenuContentChange={() => {
          setShowMenuContent((prev) => !prev);
        }}
      >
        <CDSTenantMenuRow
          leftGutter={<User color="#707070" weight="regular" size={24} />}
          rightGutter={
            <CDSButton
              onClick={handleLogout}
              sentiment="interact"
              variant="secondary"
              className="uag-btn"
              loading={logoutClicked}
              disabled={logoutClicked}
              rightIcon={!logoutClicked ? <SignOut size={16} weight="bold" /> : undefined}
            >
              Sign out
            </CDSButton>
          }
        >
          <p className="header-menu-title">SIGNED IN AS</p>
          <p className="header-menu-title-bold">{user.name}</p>
          <p className="header-menu-title-bold">{user.email}</p>
        </CDSTenantMenuRow>

        <CDSTenantMenuDivider />

        <CDSTenantMenuRow
          className="configure-row"
          leftGutter={<Gear color="#707070" weight="regular" size={24} />}
          rightGutter={
            <CDSButton
              onClick={handleGlobalSettingsClick}
              sentiment="interact"
              variant="secondary"
              className="uag-btn"
            >
              Configure
            </CDSButton>
          }
        >
          <p className="header-menu-title">GLOBAL SETTINGS</p>
        </CDSTenantMenuRow>
      </CDSTenantMenuRoot>
    </CDSHeader>
  );
};

export default Header;
